import { getAlbaranLastAvailableNumero } from "api/Albaran.service"
import { ArticuloDocumentoCreationDtoProps } from "api/DTOs/ArticuloDocumentoCreationDto"
import { ArticuloDocumentoReadingDtoProps } from "api/DTOs/ArticuloDocumentoReadingDto"
import { ConfiguracionDocumentoComercialCreationDtoProps } from "api/DTOs/ConfiguracionDocumentoComercialCreationDto"
import { ConfiguracionEmpresaGetUsuarioLoggedDtoProps } from "api/DTOs/ConfiguracionEmpresaGetUsuarioLoggedDto"
import { DireccionEmpresaGetUsuarioLoggedDtoProps } from "api/DTOs/DireccionEmpresaGetUsuarioLoggedDto"
import { EmpresaCreationDtoProps } from "api/DTOs/EmpresaCreationDto"
import { EnumReadingDtoProps } from "api/DTOs/EnumReadingDto"
import { FacturaRectificadaFacturaCreationDtoProps } from "api/DTOs/FacturaRectificadaFacturaCreationDto"
import { FicheroAdjuntoReadingDtoProps } from "api/DTOs/FicheroAdjuntoReadingDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { getFacturaLastAvailableNumero } from "api/Factura.service"
import { postFacturaProforma } from "api/FacturaProforma.service"
import { getPedidoLastAvailableNumero } from "api/Pedido.service"
import { getPresupuestoLastAvailableNumero } from "api/Presupuesto.service"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import { FormaPagoType } from "api/Types/FormaPago"
import { TipoDocumentoComercialType } from "api/Types/TipoDocumentoComercial"
import {
  TIPO_DOCUMENTO_ENUM,
  TipoDocumentoEnumType,
} from "api/Types/TipoDocumentoEnum"
import { TIPO_IMPUESTO_EMPRESA_ENUM } from "api/Types/TipoImpuestoEmpresaEnum"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { formatDate } from "common/utils/utils"
import { withFormik } from "formik"
import * as ROUTES from "routes/RoutePaths"
import { UUIDType } from "uuid"
import CreacionDocumento from "./CreacionDocumento"
import {
  COLORS_PALETTE,
  DEFAULT_DOCUMENT_IMPUESTO,
  DEFAULT_DOCUMENT_NUMBER,
  DOCUMENT_SCREEN,
  INITIAL_DOCUMENT_CURRENT,
  INITIAL_DOCUMENT_SERIE,
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
  adapterProfomaDocumento,
  esFechaOperacionValida,
  generateAndDownloadPdf,
  generateDocument,
} from "./constant"

export interface EmpresaActivaDocProps {
  id: UUIDType | string | undefined
  asesoriaId?: string | null
  cif?: string | null
  configuracion?: ConfiguracionEmpresaGetUsuarioLoggedDtoProps
  direccion?: DireccionEmpresaGetUsuarioLoggedDtoProps
  divisaAbreviatura?: string | null
  email?: string | null
  pais?: string | null
  razonSocial?: string | null
  telefono?: string | null
  logo?: {
    base64?: string | null
    mediaType?: string | null
  } | null
  logoAsBase64?: string
}

export interface DocumentoCreationDtoProps {
  adjuntos?: FicheroAdjuntoReadingDtoProps
  configuracion?: ConfiguracionDocumentoComercialCreationDtoProps
  articuloDocumentos?: $TSMigrationFixMe
  cliente?: EmpresaCreationDtoProps
  config?: {
    formasPago: {
      description: string
      id: number | null
    }[]
    cuentaContableMultiple: boolean
    screen: number
    tiposImpuestosRepercutidos: $TSMigrationFixMe
    tiposImpuestosRetenidos: $TSMigrationFixMe
  }
  descuento?: number | null
  diasPago?: number | null
  divisa?: string | null
  docAsociado?: string | null
  documentosAjustesPorDefecto?: $TSMigrationFixMe
  documentosComercialesAsociados?: UUIDType[] | string[] | null
  empresa?: $TSMigrationFixMe
  esBorrador?: boolean
  estadoRevisionActual?: number | null
  facturaProformaId?: string | null
  fechaEmision?: string | Date | null
  fechaEntrega?: string | Date | null
  fechaOperacion?: string | Date | null
  fechaVencimiento?: string | Date | null
  formaPago?: FormaPagoType | null
  id?: string
  importe: number
  impuestoRetenido?: number | null
  librado?: $TSMigrationFixMe | null
  libradoId?: string | null
  librador?: $TSMigrationFixMe | null
  libradorId?: string | null
  logo?: {
    fileAsBase64?: string
    id?: string
  }
  logoAsBase64?: string | null
  mode: string
  modoEditarBorrador: boolean
  motivo?: $TSMigrationFixMe | null
  numeroAdjuntos?: number | null
  observaciones?: string | null
  origen?: number | null
  serie?: string | null
  serieNumero?: string | null
  tarifaImpuesto?: number | null
  tipoDocumento?: TipoDocumentoEnumType
  tipoDocumentoComercial?: TipoDocumentoComercialType
  totalRetenido?: number | null
  usuario?: $TSMigrationFixMe
  cuentaContableCategoriaId?: $TSMigrationFixMe
  embalajes?: $TSMigrationFixMe
  articulosDocumento?: ArticuloDocumentoCreationDtoProps[] | null
  ficheros?: $TSMigrationFixMe
  lugarEntrega?: string | null
  retencionTipoId?: $TSMigrationFixMe
  retencionPorcentaje?: $TSMigrationFixMe
  formaPagoDescription?: $TSMigrationFixMe
  total?: $TSMigrationFixMe
  cantidadTotalArticulos?: $TSMigrationFixMe
  cuentaContableId?: $TSMigrationFixMe
  archivosAdjuntos?: $TSMigrationFixMe
  documentosAjustesPorDefectoCreationDto?: $TSMigrationFixMe
  documentoImportadoId?: $TSMigrationFixMe
  formaPagoIbanInput?: $TSMigrationFixMe
  facturaRectificativa?: FacturaRectificadaFacturaCreationDtoProps
  tags?: string[]
}

export const getNumberDocument = async (type: string, serie: string) => {
  if (type === TYPES_DOCUMENTOS.FACTURA)
    return getFacturaLastAvailableNumero(serie)
  if (type === TYPES_DOCUMENTOS.ALBARAN)
    return getAlbaranLastAvailableNumero(serie)
  if (type === TYPES_DOCUMENTOS.PEDIDO)
    return getPedidoLastAvailableNumero(serie)
  if (type === TYPES_DOCUMENTOS.PRESUPUESTO)
    return getPresupuestoLastAvailableNumero(serie)
  return DEFAULT_DOCUMENT_NUMBER
}

const LAST_COLOR_USED = "documento_last_color_used"
const validateScreen = ({ type }: { type: string }) => {
  if (type === TYPES_DOCUMENTOS.FACTURA || type === TYPES_DOCUMENTOS.PROFORMA) {
    return DOCUMENT_SCREEN.SELECT_ARTICULO
  }
  return DOCUMENT_SCREEN.SELECT_CONTACT
}

const mapPropsToValues = ({
  type,
  documento,
  empresaActiva,
  tipoImpuestos,
}: {
  type: string
  documento?: DocumentoCreationDtoProps | null
  empresaActiva?: EmpresaActivaDocProps
  tipoImpuestos?: ImpuestoEmpresaReadingDtoProps[]
}) => {
  const isFactura = type === TYPES_DOCUMENTOS.FACTURA
  const fechaVencimientoDate = new Date()
  if (documento?.diasPago) {
    fechaVencimientoDate.setDate(
      fechaVencimientoDate.getDate() + (documento.diasPago ?? 0)
    )
  }
  const cuentaContableFactura =
    empresaActiva?.configuracion?.configuracionCuentasContables?.find(
      (elemento) => elemento.categoria === CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA
    )?.cuentaContableId
  const isCompra = documento?.mode === MODES_DOCUMENTOS.COMPRA
  return {
    documentoType: {
      type,
      mode: documento?.mode ?? MODES_DOCUMENTOS.VENTA,
      screen: documento?.config?.screen ?? validateScreen({ type }),
      empresaActiva: empresaActiva?.id,
    },
    albaranLogistico: {
      niveles: null,
      screen: 0,
      pantallaActual: { id: 0, embalajeID: null },
      embalajes: [],
      distribucionProductos: [],
      TiposDeEmbalajes: [],
      productosSeleccionadosPorMover: [],
      embalajesSeleccionadosPorMover: [],
      embalajesSeleccionadosDestino: [],
      relacionesOrigenDestino: [],
    },
    empresaActiva,
    config: {
      sinValorar: false,
      cuentaContableMultiple:
        documento?.config?.cuentaContableMultiple ?? false,
      userColors: COLORS_PALETTE,
      extraColor: localStorage.getItem(LAST_COLOR_USED) ?? "#ccc",
      colorSelected:
        documento?.configuracion?.color ??
        localStorage.getItem(LAST_COLOR_USED) ??
        COLORS_PALETTE[0],
      gridArticles: true,
      modalAsociar: null,
      modeSubmitNormal: true,
      preferenceContat: null,
      isSubmitPdf: false,
      esCompraArticulos: isCompra,
      isArticlesMisArticulos: true,
      isArticlesProveredor: true,
      haveArticles: true,
    },
    modals: {
      showCreateContactoModal: false,
      showModalCarrito: false,
      showModalAsociarDoc: false,
      showObservacionesModal: false,
      showDiasPagoModal: false,
      showFormaPagoModal: false,
      showLogoModal: false,
      showDescuentoModal: false,
      showRetencionModal: false,
      showAlbaranLogisticoModal: false,
      showFechaOperacionModal: false,
      showSerieNumeroModal: false,
      showOnCreateDocumentModal: false,
      showNewEmbalajeContenedor: false,
      showModalSubmitRectificativa: false,
    },
    totales: {
      descuentoValor: 0,
      impuestosAgrupados: [],
      retencionTotal: 0,
      subtotal: 0,
      totalValor: documento?.importe ?? 0,
    },
    ficheros: documento?.ficheros ?? [],
    tipoDocumento: documento?.tipoDocumento ?? null,
    configuracion: documento?.configuracion ?? null,
    articulosDocumento: documento?.articulosDocumento
      ? [...documento.articulosDocumento].sort(
          (a, b) => (a?.orden ?? 0) - (b?.orden ?? 0)
        )
      : [],
    conceptos: documento?.articuloDocumentos
      ? documento.articuloDocumentos.map(
          (concepto: ArticuloDocumentoReadingDtoProps, index: number) => {
            const precioVenta = concepto?.articulo?.precioVenta ?? 0
            const cantidad = concepto?.cantidad ?? 0
            const tarifaImpuesto =
              concepto?.tarifaImpuesto ?? DEFAULT_DOCUMENT_IMPUESTO
            return {
              id: concepto?.articulo?.id,
              categorias: concepto?.articulo?.categorias,
              concepto: concepto?.articulo?.concepto,
              numeroReferencia: concepto?.articulo?.numeroReferencia,
              precioVenta: concepto?.articulo?.precioVenta,
              thumbnailBase64: concepto?.articulo?.thumbnailBase64,
              thumbnailMediaType: concepto?.articulo?.thumbnailMediaType,
              tipoArticulo: concepto?.articulo?.tipoArticulo,
              cantidad: concepto?.cantidad,
              impuestoArticuloTipoId:
                tipoImpuestos?.find(
                  (impuesto) =>
                    impuesto.tipo ===
                      (MODES_DOCUMENTOS.VENTA === documento.mode
                        ? TIPO_IMPUESTO_EMPRESA_ENUM.VENTA
                        : TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA) &&
                    impuesto.valor === tarifaImpuesto
                )?.id ?? null,
              impuestoArticuloPorcentaje: concepto?.tarifaImpuesto,
              impuestoNombre:
                tipoImpuestos?.find(
                  (impuesto) =>
                    impuesto.tipo ===
                      (MODES_DOCUMENTOS.VENTA === documento.mode
                        ? TIPO_IMPUESTO_EMPRESA_ENUM.VENTA
                        : TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA) &&
                    impuesto.valor === tarifaImpuesto
                )?.nombre ?? null,
              total: precioVenta * cantidad,
              cuentaContableId:
                concepto?.cuentaContableCategoriaId ||
                documento?.cuentaContableCategoriaId,
              index,
            }
          }
        )
      : [],
    descuento: documento?.descuento ?? null,
    retencionTipoId: documento?.tarifaImpuesto
      ? tipoImpuestos?.find(
          (tax: ImpuestoEmpresaReadingDtoProps) =>
            Math.abs(tax.valor) === documento?.tarifaImpuesto &&
            tax.tipo === documento?.tipoDocumentoComercial
        )?.id
      : null,
    retencionPorcentaje: documento?.tarifaImpuesto
      ? Math.abs(documento?.tarifaImpuesto)
      : null,
    diasPago:
      documento?.mode === MODES_DOCUMENTOS.VENTA
        ? documento?.diasPago ?? null
        : null,
    divisa: empresaActiva?.divisaAbreviatura ?? INITIAL_DOCUMENT_CURRENT,
    documentoImportadoId: documento?.documentoImportadoId ?? null,
    documentosAjustesPorDefectoCreationDto:
      documento?.documentosAjustesPorDefectoCreationDto ?? [],
    esBorrador: documento?.esBorrador ?? false,
    facturaProformaId: documento?.facturaProformaId ?? null,
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    fechaEmision: formatDate(new Date()),
    fechaOperacion: isFactura
      ? documento?.fechaOperacion &&
        esFechaOperacionValida(new Date(documento?.fechaOperacion))
        ? documento?.fechaOperacion
        : null
      : documento?.fechaOperacion ?? null,

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    fechaVencimiento: isFactura ? fechaVencimientoDate : formatDate(new Date()),
    formaPago: documento?.formaPago ?? null,
    formaPagoIban: null,
    formaPagoIbanInput: documento?.formaPagoIbanInput ?? null,
    formaPagoDescription: documento?.formaPago
      ? documento?.config?.formasPago?.find(
          (forma: EnumReadingDtoProps) => forma.id === documento?.formaPago
        )?.description
      : null,
    id: documento?.id,
    librado: documento?.librado
      ? {
          ...documento.librado,
          telefono:
            documento?.librado?.telefono ??
            documento?.librado?.telefonos?.[0]?.contacto ??
            null,
          email:
            documento?.librado?.email ??
            documento?.librado?.emails?.[0]?.contacto ??
            null,
        }
      : null,
    librador: documento?.librador
      ? {
          ...documento.librador,
          telefono:
            documento?.librador?.telefono ??
            documento?.librador?.telefonos?.[0]?.contacto ??
            null,
          email:
            documento?.librador?.email ??
            documento?.librador?.emails?.[0]?.contacto ??
            null,
        }
      : {
          id: null,
        },
    modoEditarBorrador: documento?.modoEditarBorrador ?? false,
    observaciones: documento?.observaciones ?? null,
    serie: documento?.serie ?? INITIAL_DOCUMENT_SERIE,
    tipoDocumentoComercial: documento?.tipoDocumentoComercial ?? null,
    documentosComercialesAsociados: documento?.docAsociado ?? null,
    documentosComercialesAsociadosId:
      documento?.tipoDocumento !== TIPO_DOCUMENTO_ENUM.FACTURA && documento?.id
        ? [documento.id]
        : null,
    documentosComercialesAsociadosPdf: null,
    cuentaContableCategoriaId: documento?.cuentaContableCategoriaId ?? null,
    total: documento?.total ?? 0,
    cantidadTotalArticulos: documento?.cantidadTotalArticulos ?? 0,
    embalajes: documento?.embalajes ?? [],
    lugarEntrega: documento?.lugarEntrega ?? null,
    logo: documento?.modoEditarBorrador ? documento.logo : empresaActiva?.logo,
    logoAsBase64: documento?.modoEditarBorrador
      ? documento?.logoAsBase64
      : empresaActiva?.logoAsBase64,
    cuentaContableId: documento?.modoEditarBorrador
      ? documento?.cuentaContableCategoriaId
      : cuentaContableFactura,
    archivosAdjuntos: documento?.modoEditarBorrador
      ? documento?.adjuntos
      : documento?.archivosAdjuntos ?? [],
    ...(type === TYPES_DOCUMENTOS.PROFORMA && {
      numeroDocumento: null,
    }),
    facturaRectificativa: documento?.facturaRectificativa ?? {
      id: undefined,
      codigoRectificativa: undefined,
      motivo: undefined,
      tipoFacturaRectificativa: undefined,
    },
    tags: [],
  }
}

const FormCreacionDocumento = withFormik({
  validateOnChange: false,
  validateOnBlur: false,
  mapPropsToValues,
  handleSubmit: async (values, { ...props }: $TSMigrationFixMe) => {
    const { t, history } = props.props
    if (values.documentoType.type === TYPES_DOCUMENTOS.PROFORMA) {
      const resp = await postFacturaProforma(adapterProfomaDocumento(values))
      if (resp.status === STATUSCORRECT) {
        return props.setFieldValue("modals.showOnCreateDocumentModal", true)
      }
    }
    if (values.documentoType.type === TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA) {
      const resp = await generateDocument(values.documentoType.type, values)
      if (resp.status === STATUSCORRECT) {
        history.push(ROUTES.FACTURAS)
        return notification.success({
          body: t("notification.correctedInvoice"),
        })
      }
    }
    if (values.config.modeSubmitNormal) {
      const resp = await generateDocument(values.documentoType.type, values)
      if (resp.status === STATUSCORRECT) {
        props.setFieldValue("modals.showOnCreateDocumentModal", true)
      }
    } else {
      props.setFieldValue("config.isSubmitPdf", true)
      await generateAndDownloadPdf(
        values.documentoType.type,
        values,
        props.props.downloadFile
      )
      props.setFieldValue("config.isSubmitPdf", false)
    }
  },
})(CreacionDocumento)

export default FormCreacionDocumento
